import request, { apiHost } from '../../utils/request';
import {
  quoteStatus,
  businessAppsOrderForm,
  orderStatus,
  businessAppsPrequalificationForm,
  businessAppsCategoryName,
  iotCategoryName,
  iotPrequalificationForm,
  constactCentreCategoryName,
  businessConnectContactCentreLandingPage,
  businessConnectQuoteToolOrderCategoryName,
  businessConnectQuoteToolForm
} from '../../utils/constant';

const apiURLOrder = id => `/orders/${id}`;

const updateOrderData = async (url, payload) => request.put(url, payload);

export const viewPDF = (locale, orderData) => {
  const { id } = orderData;
  window.open(`${apiHost}/orders/${id}/quote-pdf?lang=${locale}`, '_blank');
};

export const viewDocx = orderData => {
  const { id } = orderData;
  window.open(`${apiHost}/orders/${id}/business-app-quote`, '_blank');
};

export const movedToQuoteApproved = (formData, orderData) => {
  const { id } = orderData;
  const payload = {
    ...orderData,
    ...formData,
    status: quoteStatus.approved
  };
  return updateOrderData(apiURLOrder(id), payload);
};

export const onOrderCancelled = orderData => {
  const { id } = orderData;
  const payload = {
    ...orderData,
    status: orderStatus.orderCanceled
  };
  return updateOrderData(apiURLOrder(id), payload);
};

export const sendToSRT = (formData, orderData) => {
  const { id } = orderData;
  const payload = {
    ...orderData,
    ...formData,
    quoteStatus: quoteStatus.approved,
    sendToSRT: true
  };
  return updateOrderData(apiURLOrder(id), payload);
};

export const submitForApproval = (formData, orderData) => {
  const { id } = orderData;
  const payload = {
    ...orderData,
    ...formData,
    quoteStatus: quoteStatus.pendingApproval,
    formSubmitted: true
  };

  return updateOrderData(apiURLOrder(id), payload);
};

export const onCallcentreFormSubmit = (formData, orderData) => {
  const { id } = orderData;
  const payload = {
    ...orderData,
    ...formData,
    status: 'Submitted'
  };
  return updateOrderData(apiURLOrder(id), payload);
};

export const onBusinessAppsFormSubmit = async (
  orderData,
  locale,
  categoryName,
  formName,
  step,
  setOrderData,
  updateStep,
  history
) => {
  const searchString = (paramStep, id = '') => {
    return orderData && orderData.id
      ? `?orderId=${orderData.id}&step=${paramStep}`
      : `?orderId=${id}&step=${paramStep}`;
  };

  let updatedStatus = quoteStatus.approved;
  if (orderData && orderData.type && orderData.type === 'BA' && step === 1) {
    updatedStatus = orderStatus.incomplete;
  }

  const { id } = orderData;
  let payload = {
    ...orderData,
    status: updatedStatus,
    locale,
    categoryName,
    formName,
    step,
    formSubmitted: true
  };
  if (payload.province_address) {
    payload = { ...payload, provinceOfTheOrder: payload.province_address };
  }
  if (payload.channels && payload.channels.length) {
    payload.channelId = payload.channels[0].id;
  }
  if (payload.businessLegalName) {
    payload.legalBusinessName_businessPersonal = payload.businessLegalName;
  }
  if (payload.productInOrderFor && payload.existingCustomerBA) {
    payload[
      `existingCustomerBA_${payload.productInOrderFor.replaceAll(' ', '')}`
    ] = payload.existingCustomerBA;
  }
  if (payload.productInOrderFor && payload.existingCustomerDomain) {
    payload[
      `existingCustomerDomain_${payload.productInOrderFor.replaceAll(' ', '')}`
    ] = payload.existingCustomerDomain;
  }
  if (payload.iotPreferredLanguage) {
    payload.languageOfActivation = payload.iotPreferredLanguage;
  }

  const response = await updateOrderData(apiURLOrder(id), payload);
  setOrderData({ ...orderData, ...response.data });
  if (response) {
    if (step === 2) {
      updateStep(0);
      setOrderData();

      history.push({
        pathname: `/${locale}/${categoryName}/${businessAppsOrderForm}`
      });
    } else {
      updateStep(step + 1);
      history.push({
        pathname: `/${locale}/${categoryName}/${businessAppsOrderForm}`,
        search: searchString(step + 1, response.data.id)
      });
    }
  }
};

export const onSaveAndExit = async (
  formData,
  orderData,
  step,
  history,
  setLoading,
  locale
) => {
  setLoading(true);
  const { id } = orderData;
  let payload = { ...orderData, ...formData, step };
  if (payload.type === 'BA') {
    if (payload.province_address) {
      payload = {
        ...payload,
        provinceOfTheOrder: payload.province_address,
        formSubmitted: false
      };
    }
    if (payload.businessLegalName) {
      payload = {
        ...payload,
        legalBusinessName_businessPersonal: payload.businessLegalName
      };
    }
    if (payload.productInOrderFor && payload.existingCustomerBA) {
      payload = {
        ...payload,
        [`existingCustomerBA_${payload.productInOrderFor.replaceAll(
          ' ',
          ''
        )}`]: payload.existingCustomerBA
      };
    }
    if (payload.productInOrderFor && payload.existingCustomerDomain) {
      payload = {
        ...payload,
        [`existingCustomerDomain_${payload.productInOrderFor.replaceAll(
          ' ',
          ''
        )}`]: payload.existingCustomerDomain
      };
    }
  }
  if (payload.type === 'IOT') {
    if (payload.iotCompanyName) {
      payload = {
        ...payload,
        legalBusinessName_businessPersonal: payload.iotCompanyName
      };
    }
  }
  if (payload.type === 'BA' || payload.type === 'IOT') {
    if (payload.channels && payload.channels.length) {
      payload = { ...payload, channelId: payload.channels[0].id };
    }
    if (payload.iotPreferredLanguage) {
      payload = {
        ...payload,
        languageOfActivation: payload.iotPreferredLanguage
      };
    }
  }
  try {
    const result = await updateOrderData(apiURLOrder(id), payload);
    if (result) {
      let path = `/${locale}/${businessConnectQuoteToolOrderCategoryName}/${businessConnectQuoteToolForm}`;

      if (payload.type === 'BA')
        path = `/${locale}/${businessAppsCategoryName}/${businessAppsPrequalificationForm}`;
      if (payload.type === 'IOT')
        path = `/${locale}/${iotCategoryName}/${iotPrequalificationForm}`;
      if (payload.type === 'CC')
        path = `/${locale}/${constactCentreCategoryName}/${businessConnectContactCentreLandingPage}`;

      history.push({
        pathname: path
      });
      window.location.reload();
    }
  } catch (error) {
    throw error;
  }
};

export const onSave = (formData, orderData) => {
  const { id } = orderData;
  const payload = {
    ...orderData,
    ...formData
  };
  return updateOrderData(apiURLOrder(id), payload);
};
